'use client';

import { c as _c } from "react/compiler-runtime";
import { type UseFormReturn } from 'react-hook-form';
import { Button } from '@module/mdrt-org/shared/components/button/button';
import { FieldController } from '@module/mdrt-org/shared/components/field-controller/field-controller';
import { SelectField } from '@module/mdrt-org/shared/components/select-field/select-field';
import { MAX_CITY_LENGTH, MAX_USERNAME_LENGTH } from '@module/mdrt-org/shared/utils/constants/inputs-constants';
import { type MembershipLevel } from '@module/mdrt-org/shared/utils/enums/membership';
import { SEARCH_QUERY_TRANSFORM_REGEXP } from '@module/mdrt-org/shared/utils/types/regexp';
import { Card } from '@shared/ui-components/card/card';
import { FormInput } from '@shared/ui-components/form-input/form-input';
import { FormWrapper } from '@shared/ui-components/form-wrapper/form-wrapper';
import { allowedRegExpTransform } from '@shared/utils/helpers/allowedRegExpTransform';
import { collapseSpaces } from '@shared/utils/helpers/sanitize-url-text-parameter';
import { type SelectOption } from '@shared/utils/types/select-option';
import { type MemberDirectoryPageContent } from '../get-member-directory-page-content';
import { type SearchFormData } from '../search/search';
import { useCountryStatesQuery } from '../use-country-states-query';
import styles from './search-form.module.scss';
export const SearchForm = t0 => {
  const $ = _c(38);
  const {
    canFilterByMembershipLevel,
    cmsContent,
    countryOptions,
    formMethods,
    membershipLevelOptions,
    onSubmit
  } = t0;
  const {
    watch
  } = formMethods;
  const selectedCountryId = watch("country")?.value;
  let t1;
  if ($[0] !== selectedCountryId) {
    t1 = {
      selectedCountryId
    };
    $[0] = selectedCountryId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    isCountryStatesDataLoading,
    stateOptions
  } = useCountryStatesQuery(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = allowedRegExpTransform(SEARCH_QUERY_TRANSFORM_REGEXP);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const allowedQueryTransform = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      input: value => collapseSpaces(allowedQueryTransform.input(value)),
      output: event => collapseSpaces(allowedQueryTransform.output(event))
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const searchQueryTransform = t3;
  const isAnyFieldFilled = Object.values(formMethods.watch()).some(_temp);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FormInput />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== cmsContent.searchInputLabel) {
    t5 = <div className={styles["form__search-field-container"]}><FieldController label={cmsContent.searchInputLabel} maxLength={MAX_USERNAME_LENGTH} name="searchQuery" transform={searchQueryTransform}>{t4}</FieldController></div>;
    $[5] = cmsContent.searchInputLabel;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== formMethods) {
    t6 = () => {
      formMethods.setValue("stateOrProvince", null);
    };
    $[7] = formMethods;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== cmsContent.countryLabel || $[10] !== countryOptions || $[11] !== t6) {
    t7 = <div className={styles["form__address-fields-item"]}><SelectField isClearable={true} isSearchable={true} label={cmsContent.countryLabel} name="country" onChange={t6} options={countryOptions} /></div>;
    $[9] = cmsContent.countryLabel;
    $[10] = countryOptions;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = stateOptions.length === 0 || isCountryStatesDataLoading;
  let t9;
  if ($[13] !== cmsContent.stateLabel || $[14] !== stateOptions || $[15] !== t8) {
    t9 = <div className={styles["form__address-fields-item"]}><SelectField isClearable={true} isDisabled={t8} isSearchable={true} label={cmsContent.stateLabel} name="stateOrProvince" options={stateOptions} /></div>;
    $[13] = cmsContent.stateLabel;
    $[14] = stateOptions;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <FormInput />;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== cmsContent.cityLabel) {
    t11 = <div className={styles["form__address-fields-item"]}><FieldController label={cmsContent.cityLabel} maxLength={MAX_CITY_LENGTH} name="city" transform={searchQueryTransform}>{t10}</FieldController></div>;
    $[18] = cmsContent.cityLabel;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11 || $[21] !== t7 || $[22] !== t9) {
    t12 = <div className={styles["form__address-fields"]}>{t7}{t9}{t11}</div>;
    $[20] = t11;
    $[21] = t7;
    $[22] = t9;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== canFilterByMembershipLevel || $[25] !== cmsContent.membershipLevelLabel || $[26] !== membershipLevelOptions) {
    t13 = canFilterByMembershipLevel && <div className={styles["form__membership-type-field-container"]}><SelectField isClearable={true} label={cmsContent.membershipLevelLabel} name="membershipLevel" options={membershipLevelOptions} /></div>;
    $[24] = canFilterByMembershipLevel;
    $[25] = cmsContent.membershipLevelLabel;
    $[26] = membershipLevelOptions;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  const t14 = !isAnyFieldFilled;
  let t15;
  if ($[28] !== cmsContent.searchButtonLabel || $[29] !== t14) {
    t15 = <div className={styles["form__search-button-container"]}><Button className={styles.form__button} disabled={t14} type="submit">{cmsContent.searchButtonLabel}</Button></div>;
    $[28] = cmsContent.searchButtonLabel;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== formMethods || $[32] !== onSubmit || $[33] !== t12 || $[34] !== t13 || $[35] !== t15 || $[36] !== t5) {
    t16 = <Card className={styles["search-form-container"]} elevation={1}><FormWrapper className={styles.form} dataTestId="member-directory-search" formMethods={formMethods} onSubmit={onSubmit}>{t5}{t12}{t13}{t15}</FormWrapper></Card>;
    $[31] = formMethods;
    $[32] = onSubmit;
    $[33] = t12;
    $[34] = t13;
    $[35] = t15;
    $[36] = t5;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  return t16;
};
function _temp(value_0) {
  return value_0 !== "" && value_0 !== null;
}